<div class="container">
  <ui-toast></ui-toast>
  <app-menu class="menu"></app-menu>

  <div class="page">
    <div class="page-container">
      @if (linkInvalid) {
        <div class="page-message" data-testid="reset-password-invalid-link">
          <h2 class="page-message-title">{{ 'RESET_PASSWORD.INVALID_LINK_TITLE' | transloco }}</h2>
          <p class="page-message-text">{{ 'RESET_PASSWORD.INVALID_LINK_TEXT' | transloco }}</p>
          <a class="page-message-link" data-testid="request-new-link" routerLink="/forgot-password">{{ 'RESET_PASSWORD.REQUEST_NEW' | transloco }}</a>
        </div>
      } @else {
        <form [formGroup]="form" (ngSubmit)="submit()">
          <h2 class="page-title" data-testid="reset-password-title">{{ 'RESET_PASSWORD.TITLE' | transloco }}</h2>
          <p class="page-description">{{ 'RESET_PASSWORD.DESCRIPTION' | transloco }}</p>

          @if (error(); as resetError) {
            <div class="page-error" data-testid="reset-password-error">
              <span class="page-error-text">{{ 'RESET_PASSWORD.ERRORS.' + resetError | transloco }}</span>
              @if (resetError === 'EXPIRED' || resetError === 'INVALID') {
                <a class="page-error-link" data-testid="request-new-link" routerLink="/forgot-password">{{ 'RESET_PASSWORD.REQUEST_NEW' | transloco }}</a>
              }
            </div>
          }

          <div class="page-fields">
            <div class="page-fields-item">
              <div class="page-fields-item-label" data-testid="password-label">{{ 'RESET_PASSWORD.NEW_PASSWORD' | transloco }}</div>
              <ui-password-field
                data-testid="password-input"
                class="page-fields-item"
                formControlName="password">
              </ui-password-field>
            </div>

            <div class="page-fields-item">
              <div class="page-fields-item-label" data-testid="confirm-password-label">{{ 'RESET_PASSWORD.CONFIRM_PASSWORD' | transloco }}</div>
              <ui-password-field
                data-testid="confirm-password-input"
                class="page-fields-item"
                formControlName="confirmPassword">
              </ui-password-field>
            </div>
          </div>

          <div class="page-buttons">
            <ui-button
              data-testid="submit-btn"
              class="page-buttons-button"
              type="submit"
              [loading]="isSubmitting">
              {{ 'RESET_PASSWORD.SUBMIT' | transloco }}
            </ui-button>
            <a class="page-back" data-testid="back-to-login-link" routerLink="/login">{{ 'FORGOT_PASSWORD.BACK' | transloco }}</a>
          </div>
        </form>
      }
    </div>
  </div>
</div>
